import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MenuItemPath, MenuItem } from '@enums/menu-item.enum';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { TonnageComponent } from './pages/tonnage/tonnage.component';

const routes: Routes = [
    {
      path: MenuItemPath.get(MenuItem.tonnage),
      component: TonnageComponent,
      canActivate: [AuthGuard]
    }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
})

export class TonnageRoutingModule { }
